<template>
    <div class="create-page__custom-form-wrapper">
        <!-- COMBINATION_COMPONENT_TYPE_CARD -->
        <template v-if="needCard">
            <custom-card v-bind="cardNeedProps">
                <create-form ref="form" v-bind="createFormNeedProps" title="" />
            </custom-card>
        </template>

        <!-- COMBINATION_COMPONENT_TYPE_PAGE -->
        <template v-else-if="needPageHeader">
            <weight-page-header v-bind="pageHeaderNeedProps" :title="title" />
            <create-form ref="form" v-bind="createFormNeedProps" title="" />
        </template>

        <!-- COMBINATION_COMPONENT_TYPE_NOMAL -->
        <template v-else>
            <create-form ref="form" v-bind="createFormNeedProps" />
        </template>
    </div>
</template>
<script>
import CreateForm from '@weights/CreateForm'
import CustomCard from '@weights/CustomCard'
import WeightPageHeader from '@weights/PageHeader'

import childrenRefreshMixin from '@mixins/createPage/childrenRefresh'
import getFormData from '@mixins/createPage/formData'
import eventMixin from '@mixins/createPage/event'
import buttonMixin from '@mixins/createPage/button'

import { getPropFields, getPropsInNeed, getPropsInCardNeed, getPropsInPageHeaderNeed } from '@utils/pageCreate'

import { COMBINATION_COMPONENT_TYPE_CARD, COMBINATION_COMPONENT_TYPE_PAGE, BOOLEAN_PATTERN_TRUE } from '@constant/enum'

const CREATE_FORM_PROP_FIELDS = getPropFields(CreateForm)

export default {
    name: 'CreateCustomForm',
    components: {
        CreateForm,
        CustomCard,
        WeightPageHeader
    },
    mixins: [
        childrenRefreshMixin, getFormData, eventMixin, buttonMixin
    ],
    props: {
        combinationComponentType: {
            type: Number,
            default: COMBINATION_COMPONENT_TYPE_CARD
        },
        title: {
            type: String,
            default: ''
        },
        data: {
            type: [Object, Array],
            default() {
                return {}
            }
        },
        eventList: {
            type: Array,
            default: () => []
        },
        extraTitle: {
            type: Object,
            default: () => ({})
        },
        // 展示边框
        needBordered: {
            type: Number,
            default: BOOLEAN_PATTERN_TRUE
        },
        fieldList: {
            type: Array,
            default: () => []
        },
        field: {
            type: String,
            default: ''
        },
        columns: {
            type: Number,
            default: 1
        },
        options: {
            type: Object,
            default() {
                return {
                    submitBtn: false,
                    resetBtn: false
                }
            }
        },
        emits: {
            type: Object,
            default: () => ({})
        },
        childrenField: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        needCard() {
            return this.combinationComponentType === COMBINATION_COMPONENT_TYPE_CARD
        },
        needPageHeader() {
            return this.combinationComponentType === COMBINATION_COMPONENT_TYPE_PAGE
        },
        cardNeedProps() {
            return this.needCard ? getPropsInCardNeed(this.$props) : null
        },
        pageHeaderNeedProps() {
            return this.needPageHeader ? getPropsInPageHeaderNeed(this.$props) : null
        },
        createFormNeedProps() {
            return getPropsInNeed(this.$props, CREATE_FORM_PROP_FIELDS)
        }
    },
    methods: {
        getChildFApi() {
            return this.$refs['form']?.fApi
        },
        getFormData() {
            return this.$refs['form'].getFormData()
        },
        clickHandle() {
            console.log(this.getFormData())
        },
        vaildatorForm(cb) {
            this.$refs['form'].vaildatorForm(cb)
        }
    }
}
</script>
